import { useDateCalculations } from './useDateCalculations';
import { usePeriodNavigation } from './usePeriodNavigation';
import { useDatePicker } from './useDatePicker';

/**
 * Main custom hook for PeriodSelector component
 * Combines all period selector logic into a single, reusable hook
 * @param {Object} props - Component props
 * @returns {Object} All period selector functionality
 */
export const usePeriodSelector = (props) => {
  // Get date calculations and memoized values
  const { startDate, endDate, dateCalculations, rangePickerValue } = useDateCalculations(props);

  // Get period navigation functionality
  const { changePeriod } = usePeriodNavigation({
    startDate,
    endDate,
    dateCalculations,
    setStartDate: props.setStartDate,
    setEndDate: props.setEndDate
  });

  // Get date picker functionality
  const { rangePresets, handleDateChange } = useDatePicker(
    props.setStartDate,
    props.setEndDate
  );

  return {
    // Date objects and calculations
    startDate,
    endDate,
    dateCalculations,
    rangePickerValue,
    
    // Navigation
    changePeriod,
    
    // Date picker
    rangePresets,
    handleDateChange
  };
};
